// extracted by mini-css-extract-plugin
module.exports = {"action_made_by_container":"ActionMadeBy_action_made_by_container__feMZF","modal_heading":"ActionMadeBy_modal_heading__1cbXF","action_made_by":"ActionMadeBy_action_made_by__2TqN3"};